export default {
  Auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_0Xz9K7XGc",
    userPoolWebClientId: "7t1spfje1u5dndpbvi9ocoud2n"
  }
}